module.exports = "<div class=\"app-pix-home\">\n\t<app-main-title title=\"Pix\" subtitle=\"Faça e receba pagamentos instantâneos 24 horas por dia\"></app-main-title>\n\t<app-current-balance></app-current-balance>\n\t<app-pix-home-menu [selectedPixMenu]=\"pixMenu.EXTRATO\"></app-pix-home-menu>\n\t<app-pix-extract></app-pix-extract>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/home/home.component.html
// module id = ../../../../../src/app/master/pix/home/home.component.html
// module chunks = main